module.exports = __webpack_public_path__ + "static/pub-d91018c37f383a9d48bc1085b4a6c4ac.svg";